export default __webpack_public_path__ + "static/wpAdPageBanner-78097f99264c1b34a0277e3bc23444ac.webp";